import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDozJCn9L0tBkZGtgtYXr62VuDJ3BW8888",
    authDomain: "shashwat-pal.firebaseapp.com",
    projectId: "shashwat-pal",
    storageBucket: "shashwat-pal.appspot.com",
    messagingSenderId: "5049955052",
    appId: "1:5049955052:web:1266f02b77d0be1db0abc9"
  };

  const firebaseApp=firebase.initializeApp(firebaseConfig);
  const db=firebaseApp.firestore();
  export {db};